/**
 * 团队水印相关配置
 */

import dayjs from 'dayjs'

//预设颜色
export const PRESET_COLORS = [
  '#0060FF',
  '#19C0BF',
  '#00A80D',
  '#FF7800',
  '#D80007',
  '#A901AB',
  '#00BCFF',
  '#1DE9B6',
  '#64DD17',
  '#FFC233',
  '#FF5252',
  '#CE48FF',
  '#43E8FF',
  '#64FFDA',
  '#76FF03',
  '#FFEF40',
  '#FFAB91',
  '#ED84FF',
  '#000000',
  '#FFFFFF'
]

//基础水印ID
export const BASE_ID = {
  ID_10: '10',
  ID_20: '20',
  ID_21: '21',
  ID_27: '27',
  ID_43: '43',
  ID_45: '45',
  ID_46: '46',
  ID_35: '35',
  ID_50: '50'
}

export const EDITABLE_BASE_IDS = [
  BASE_ID.ID_10,
  BASE_ID.ID_20,
  BASE_ID.ID_21,
  BASE_ID.ID_27,
  BASE_ID.ID_43,
  BASE_ID.ID_45,
  BASE_ID.ID_46,
  BASE_ID.ID_35,
  BASE_ID.ID_50
]

export const TEMPLATES = [
  {
    id: BASE_ID.ID_10,
    name: '自定义水印',
    cover: `https://net-cloud.xhey.top/watermark/cover/10.png`
  },
  {
    id: BASE_ID.ID_20,
    name: '工程水印',
    cover: `https://net-cloud.xhey.top/watermark/cover/20.png`
  },
  {
    id: BASE_ID.ID_21,
    name: '考勤打卡',
    cover: `https://net-cloud.xhey.top/watermark/cover/21.png`
  },
  {
    id: BASE_ID.ID_27,
    name: '秒表水印',
    cover: `https://net-cloud.xhey.top/watermark/cover/27.png`
  },
  {
    id: BASE_ID.ID_43,
    name: '执勤水印',
    cover: `https://net-cloud.xhey.top/watermark/cover/43.png`
  },
  {
    id: BASE_ID.ID_45,
    name: '疫情防控水印',
    cover: `https://net-cloud.xhey.top/watermark/cover/45.png`
  },
  {
    id: BASE_ID.ID_46,
    name: '品牌水印',
    cover: `https://net-cloud.xhey.top/watermark/cover/46.png`
  },
  {
    id: BASE_ID.ID_35,
    name: '亓道经纬水印',
    cover: `https://net-cloud.xhey.top/watermark/cover/35.png`
  }
  // {
  //   id: BASE_ID.ID_50,
  //   name: '民情日记水印',
  //   cover: `https://net-cloud.xhey.top/watermark/cover/50.png`
  // }
]

//条目ID
export const ITEM_ID = {
  ID_1: 1,
  ID_2: 2,
  ID_3: 3,
  ID_4: 4,
  ID_5: 5,
  ID_6: 6,
  ID_7: 7,
  ID_11: 11,
  ID_13: 13,
  ID_14: 14,
  ID_15: 15,
  ID_16: 16,
  ID_17: 17,
  ID_12: 12,
  ID_18: 18,
  ID_19: 19,
  ID_20: 20,
  ID_21: 21,
  ID_22: 22,
  ID_30: 30,
  ID_110: 110,
  ID_200: 200,
  ID_300: 300,
  ID_400: 400,
  ID_410: 410,
  ID_500: 500
}

export const ITEM_IDS = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  30,
  110,
  120,
  200,
  300,
  400,
  410,
  500
]

//时间条目样式列表
export const DATE_TIME_STYLES = [
  {
    id: 100,
    content: '日期+时刻',
    example: '2019.12.11 09:00'
  },
  {
    id: 101,
    content: '日期+星期',
    example: '2019.12.11 星期三'
  },
  {
    id: 102,
    content: '星期+时刻',
    example: '星期三 09:00'
  },
  {
    id: 103,
    content: '日期',
    example: '2019.12.11'
  },
  {
    id: 104,
    content: '日期+星期+时刻',
    example: '2019.12.11 星期三 09:00'
  },
  {
    id: 105,
    content: '星期',
    example: '星期一'
  },
  {
    id: 106,
    content: '时刻',
    example: '09:00'
  },
  {
    id: 107,
    content: '日期+时分秒',
    example: '2019-12-11 09:00:01'
  },
  {
    id: 108,
    content: '日期+时分秒',
    example: '2019.12.11 09:00:01'
  }
]

//天气条目样式列表
export const WEATHER_STYLES = [
  {
    id: 200,
    content: '天气+温度',
    example: '晴 22℃'
  },
  {
    id: 202,
    content: '天气+温度+风速',
    example: '晴 22℃  东风≤3级'
  },
  {
    id: 201,
    content: '天气+温度+风速+湿度',
    example: '晴 22℃  东风≤3级  湿度20%'
  },
  {
    id: 204,
    content: '天气+温度+风速+体感温度',
    example: '晴 22℃  东风≤3级  体感21℃'
  },
  {
    id: 205,
    content: '天气+温度+风速+空气质量',
    example: '晴 22℃  东风≤3级  空气质量33 优'
  },
  {
    id: 206,
    content: '天气+温度+风速+气压',
    example: '晴 22℃  东风≤3级  气压1080百帕'
  }
]

//地址条目样式列表
export const ADDRESS_STYLES = [
  {
    id: 300,
    content: '城市+地点',
    example: '安阳市·创业大厦'
  },
  {
    id: 301,
    content: '区+地点',
    example: '龙安区·创业大厦'
  },
  {
    id: 302,
    content: '省+城市+地点',
    example: '河南省安阳市·创业大厦'
  },
  {
    id: 303,
    content: '城市+区+地点',
    example: '安阳市龙安区·创业大厦'
  },
  {
    id: 304,
    content: '区+乡镇+地点',
    example: '龙安区龙泉镇·创业大厦'
  },
  {
    id: 305,
    content: '城市+区+乡镇+地点',
    example: '安阳市龙安区龙泉镇·创业大厦'
  },
  {
    id: 306,
    content: '省+城市+区+乡镇+地点',
    example: '河南省安阳市龙安区龙泉镇·创业大厦'
  }
]

//海拔条目样式列表
export const ALTITUDE_STYLES = [
  {
    id: 400,
    content: '高度',
    example: '48米'
  }
]

//方位角条目样式列表
export const AZIMUTH_STYLES = [
  {
    id: 600,
    content: '方向+角度',
    example: '西北315°'
  }
]

//方位角条目样式列表
export const SPEED_STYLES = [
  {
    id: 700,
    content: '公里/小时',
    example: '24.1 公里/小时'
  }
]

//经纬度条目样式列表
export const GPS_STYLES = [
  {
    id: 500,
    content: '度',
    example: '116.271612°E , 39.561234°N'
  },
  {
    id: 501,
    content: '度分秒',
    example: `116°27'16"E , 39°56'4"N`
  },
  {
    id: 502,
    content: '度分',
    example: `北纬116°27' , 东经39°56'`
  },
  {
    id: 510,
    content: '度（无单位）',
    example: `116.271612 , 39.561234`
  }
]

export const ID_300_STYLES = [
  {
    id: 0,
    content: '防伪水印',
    example: '现场拍照'
  }
]

export const IMEI_STYLES = [
  {
    id: 5000,
    content: '仅安卓设备',
    example: '手机串码'
  }
]

const TOOLTIPS = {
  DATE_TIME: '时间将根据拍摄时间显示',
  WEATHER: '天气将根据实际天气变化显示',
  ADDRESS: '具体地点将根据拍摄者所在位置显示',
  ALTITUDE: '海拔将根据拍摄者所在位置显示',
  AZIMUTH: '方位角将根据拍摄者所在位置显示',
  GPS: '经纬度将根据拍摄者所在位置显示',
  ID_300: '现场拍照水印仅在拍摄时开启',
  IMEI: 'IMEI将根据拍摄者设备情况显示',
  SPEED: '速度将根据拍摄者实际情况显示'
}

//条目的可编辑类型
export const EDIT_TYPES = {
  CAN_NOT_EDIT: 0, //不能编辑条目
  ONLY_TITLE: 1, //只能编辑标题
  ONLY_CONTENT: 2, //只能编辑内容
  TITLE_CONTENT: 3, //可编辑标题和内容
  ALLOW_ADDRESS: 4 //允许修改地点
}

//必填项的清空类型
export const MUST_FILLED_CLEAR_TYPES = {
  FIVE_MINUTES: 1, //每5分钟清空
  NEVER: 2 //始终不清空
}

export const PRESET_ITEM_MAX_CHAR_LENGTH = 530 * 2

/**
 * 水印规则配置
 */
export const WATERMARK_CONFIG = {
  [BASE_ID.ID_10]: {
    watermark: {
      base_id: '10',
      groupId: '',
      id: '',
      items: [
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 11,
          style: 0,
          switchStatus: false,
          title: '自定义文字',
          userCustom: false
        },
        {
          style: 0,
          content: '自动生成唯一编号',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          id: 410,
          editType: 4100,
          title: '编号',
          switchStatus: false,
          userCustom: false
        },
        {
          content: '日期+时刻',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 100,
          switchStatus: false,
          title: '时间',
          userCustom: false
        },
        {
          content: '天气+温度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 4,
          style: 200,
          switchStatus: false,
          title: '天气',
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: false,
          title: '地点',
          userCustom: false
        },
        {
          content: '高度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 5,
          style: 400,
          switchStatus: false,
          title: '海拔',
          userCustom: false
        },
        {
          content: '方向+角度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 6,
          style: 600,
          switchStatus: false,
          title: '方位角',
          userCustom: false
        },
        {
          content: '公里/小时',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 7,
          style: 700,
          switchStatus: false,
          title: '速度',
          userCustom: false
        },
        {
          content: '度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 3,
          style: 500,
          switchStatus: false,
          title: '经纬度',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 13,
          style: 0,
          switchStatus: false,
          title: '拍摄人',
          userCustom: true
        }
      ],
      logo: {
        alpha: '1.0',
        id: 14,
        scale: '0.23',
        switchStatus: false,
        url: ''
      },
      name: '',
      theme: {
        alpha: '1.0',
        color: '#ffc233',
        id: 110,
        switchStatus: true,
        textColor: '#ffffff'
      },
      update_time: '',
      version: '7'
    },
    allowCustomItem: true, //支持自定义条目
    customItem: {
      titleMaxSize: 20,
      contentMaxSize: 530
    },
    optionItems: [1, 2, 3, 4, 5, 6, 7], //option类条目
    theme: {
      displayName: '主题风格', //theme条目在此水印中的名称
      editable: ['color', 'textColor'], //theme的可编辑项目
      minFont: 0.4,
      maxFont: 1.4,
      minSize: 0.6,
      maxSize: 1.2
    },
    logo: {
      displayName: '品牌图片', //logo条目在不同水印中的名称
      editable: ['scale', 'alpha']
    },
    [ITEM_ID.ID_1]: {
      tooltip: TOOLTIPS.DATE_TIME, //提示信息
      styles: DATE_TIME_STYLES,
      options: [100, 101, 102, 103, 104, 105, 106, 108] //此水印此条目允许选择哪些样式，[]为所有样式
    },
    [ITEM_ID.ID_4]: {
      tooltip: TOOLTIPS.WEATHER, //提示信息
      cardStyle: {
        width: '230px'
      },
      styles: WEATHER_STYLES,
      options: [] //此水印此条目允许选择哪些样式，[]为所有样式
    },
    [ITEM_ID.ID_2]: {
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_5]: {
      tooltip: TOOLTIPS.ALTITUDE,
      cardStyle: {
        width: '230px'
      },
      styles: ALTITUDE_STYLES,
      options: [400]
    },
    [ITEM_ID.ID_6]: {
      tooltip: TOOLTIPS.AZIMUTH,
      cardStyle: {
        width: '230px'
      },
      styles: AZIMUTH_STYLES,
      options: [600]
    },
    [ITEM_ID.ID_7]: {
      tooltip: TOOLTIPS.SPEED,
      cardStyle: {
        width: '230px'
      },
      styles: SPEED_STYLES,
      options: [700]
    },
    [ITEM_ID.ID_3]: {
      tooltip: TOOLTIPS.GPS,
      cardStyle: {
        width: '230px'
      },
      styles: GPS_STYLES,
      options: [500, 501, 502]
    },
    [ITEM_ID.ID_11]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_13]: {
      titleMaxSize: 20,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_400]: {
      titleEditable: false
    },
    [ITEM_ID.ID_410]: {
      titleMaxSize: 12
    }
  },
  [BASE_ID.ID_20]: {
    watermark: {
      base_id: '20',
      groupId: '',
      id: '',
      items: [
        {
          content: '工程记录',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 13,
          style: 0,
          switchStatus: false,
          title: '工程名称',
          userCustom: false
        },
        {
          style: 0,
          content: '自动生成唯一编号',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          id: 410,
          editType: 4100,
          title: '编号',
          switchStatus: false,
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 14,
          style: 0,
          switchStatus: false,
          title: '施工区域',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 15,
          style: 0,
          switchStatus: false,
          title: '施工内容',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 16,
          style: 0,
          switchStatus: false,
          title: '施工责任人',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 17,
          style: 0,
          switchStatus: false,
          title: '监理责任人',
          userCustom: false
        },
        {
          content: '日期+时刻',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 100,
          switchStatus: false,
          title: '拍摄时间',
          userCustom: false
        },
        {
          content: '天气+温度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 4,
          style: 200,
          switchStatus: false,
          title: '天气',
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: false,
          title: '地点',
          userCustom: false
        },
        {
          content: '高度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 5,
          style: 400,
          switchStatus: false,
          title: '海拔',
          userCustom: false
        },
        {
          content: '方向+角度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 6,
          style: 600,
          switchStatus: false,
          title: '方位角',
          userCustom: false
        },
        {
          content: '公里/小时',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 7,
          style: 700,
          switchStatus: false,
          title: '速度',
          userCustom: false
        },
        {
          content: '度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 3,
          style: 500,
          switchStatus: false,
          title: '经纬度',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 12,
          style: 0,
          switchStatus: false,
          title: '备注',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 18,
          style: 0,
          switchStatus: false,
          title: '建设单位',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 19,
          style: 0,
          switchStatus: false,
          title: '监理单位',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 20,
          style: 0,
          switchStatus: false,
          title: '施工单位',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 21,
          style: 0,
          switchStatus: false,
          title: '设计单位',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 22,
          style: 0,
          switchStatus: false,
          title: '勘察单位',
          userCustom: false
        }
      ],
      logo: {
        alpha: '1.0',
        id: 120,
        switchStatus: false,
        url: ''
      },
      name: '',
      theme: {
        alpha: '0.5',
        color: '#0060ff',
        id: 23,
        sizeScale: '1.0',
        fontScale: '1.0',
        switchStatus: true,
        textColor: '#000000'
      },
      update_time: '',
      version: '8'
    },
    allowCustomItem: true,
    optionItems: [1, 4, 2, 5, 6, 3, 7],
    theme: {
      displayName: '颜色与样式', //theme条目在此水印中的名称
      editable: ['color', 'sizeScale', 'alpha'], //theme的可编辑项目
      minFont: 0.46,
      maxFont: 1.6,
      minSize: 0.7,
      maxSize: 1.5
    },
    logo: {
      displayName: '品牌图片', //logo条目在不同水印中的名称
      editable: []
    },
    [ITEM_ID.ID_1]: {
      tooltip: TOOLTIPS.DATE_TIME, //提示信息
      styles: DATE_TIME_STYLES,
      options: [100, 101, 102, 103, 104, 105, 106, 108] //此水印此条目允许选择哪些样式，[]为所有样式
    },
    [ITEM_ID.ID_4]: {
      tooltip: TOOLTIPS.WEATHER, //提示信息
      cardStyle: {
        width: '230px'
      },
      styles: WEATHER_STYLES,
      options: [] //此水印此条目允许选择哪些样式，[]为所有样式
    },
    [ITEM_ID.ID_2]: {
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_5]: {
      tooltip: TOOLTIPS.ALTITUDE,
      cardStyle: {
        width: '230px'
      },
      styles: ALTITUDE_STYLES,
      options: [400]
    },
    [ITEM_ID.ID_6]: {
      tooltip: TOOLTIPS.AZIMUTH,
      cardStyle: {
        width: '230px'
      },
      styles: AZIMUTH_STYLES,
      options: [600]
    },
    [ITEM_ID.ID_7]: {
      tooltip: TOOLTIPS.SPEED,
      cardStyle: {
        width: '230px'
      },
      styles: SPEED_STYLES,
      options: [700]
    },
    [ITEM_ID.ID_3]: {
      tooltip: TOOLTIPS.GPS,
      cardStyle: {
        width: '230px'
      },
      styles: GPS_STYLES,
      options: [500, 501, 502]
    },
    [ITEM_ID.ID_13]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_400]: {
      titleEditable: false
    },
    [ITEM_ID.ID_12]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_14]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_15]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_16]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_17]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_18]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_19]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_20]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_21]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_22]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_410]: {
      titleMaxSize: 12
    }
  },
  [BASE_ID.ID_21]: {
    watermark: {
      base_id: '21',
      groupId: '',
      id: '',
      items: [
        {
          content: '时刻',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 106,
          switchStatus: true,
          title: '拍摄时间',
          userCustom: false
        },
        {
          style: 0,
          content: '自动生成唯一编号',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          id: 410,
          editType: 4100,
          title: '编号',
          switchStatus: false,
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 2,
          style: 300,
          switchStatus: true,
          title: '地点',
          userCustom: false
        },
        {
          content: '日期+星期',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 11,
          style: 101,
          switchStatus: true,
          title: '拍摄日期',
          userCustom: false
        },
        {
          content: '度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 3,
          style: 500,
          switchStatus: false,
          title: '经纬度',
          userCustom: false
        },
        {
          content: '天气+温度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 4,
          style: 200,
          switchStatus: false,
          title: '天气',
          userCustom: false
        },
        {
          content: '公里/小时',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 7,
          style: 700,
          switchStatus: false,
          title: '速度',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 12,
          style: 0,
          switchStatus: false,
          title: '备注',
          userCustom: false
        }
      ],
      name: '',
      update_time: '',
      version: '6'
    },
    allowCustomItem: true,
    optionItems: [1, 2, 11, 3, 4, 7],
    [ITEM_ID.ID_1]: {
      switchDisabled: true,
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [106]
    },
    [ITEM_ID.ID_2]: {
      switchDisabled: true,
      forbidEmployeeModify: true,
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: [300]
    },
    [ITEM_ID.ID_11]: {
      switchDisabled: true,
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [101]
    },
    [ITEM_ID.ID_3]: {
      tooltip: TOOLTIPS.GPS,
      cardStyle: {
        width: '230px'
      },
      styles: GPS_STYLES,
      options: [500, 501, 502]
    },
    [ITEM_ID.ID_4]: {
      tooltip: TOOLTIPS.WEATHER,
      cardStyle: {
        width: '230px'
      },
      styles: WEATHER_STYLES,
      options: [] //此水印此条目允许选择哪些样式，[]为所有样式
    },
    [ITEM_ID.ID_7]: {
      tooltip: TOOLTIPS.SPEED,
      cardStyle: {
        width: '230px'
      },
      styles: SPEED_STYLES,
      options: [700]
    },
    [ITEM_ID.ID_12]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_410]: {
      titleMaxSize: 12
    }
  },
  [BASE_ID.ID_27]: {
    watermark: {
      base_id: '27',
      groupId: '',
      id: '',
      items: [
        {
          content: '日期+时分秒',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 107,
          switchStatus: true,
          title: '拍摄时间',
          userCustom: false
        },
        {
          style: 0,
          content: '自动生成唯一编号',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          id: 410,
          editType: 4100,
          title: '编号',
          switchStatus: false,
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 12,
          style: 0,
          switchStatus: true,
          title: '自定义文字',
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: true,
          title: '地点',
          userCustom: false
        }
      ],
      name: '',
      update_time: '',
      version: '3'
    },
    allowCustomItem: false,
    optionItems: [1, 2],
    fixedTitleItems: [12],
    [ITEM_ID.ID_1]: {
      switchDisabled: true,
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [107]
    },
    [ITEM_ID.ID_2]: {
      switchDisabled: true,
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_12]: {
      switchDisabled: true,
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_410]: {
      titleMaxSize: 12
    }
  },
  [BASE_ID.ID_43]: {
    watermark: {
      base_id: '43',
      groupId: '',
      id: '',
      items: [
        {
          content: '日期+时刻',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 100,
          switchStatus: true,
          title: '拍摄时间',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 13,
          style: 0,
          switchStatus: false,
          title: '大标题',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 14,
          style: 0,
          switchStatus: false,
          title: '小标题',
          userCustom: false
        },
        {
          style: 0,
          content: '自动生成唯一编号',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          id: 410,
          editType: 4100,
          title: '编号',
          switchStatus: false,
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: false,
          title: '地点',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 12,
          style: 0,
          switchStatus: false,
          title: '备注',
          userCustom: false
        }
      ],
      name: '',
      update_time: '',
      version: '3'
    },
    allowCustomItem: true,
    optionItems: [1, 2],
    [ITEM_ID.ID_1]: {
      switchDisabled: true,
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [100]
    },
    [ITEM_ID.ID_2]: {
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_13]: {
      titleEditable: false,
      contentMaxSize: 20
    },
    [ITEM_ID.ID_14]: {
      titleEditable: false,
      contentMaxSize: 50
    },
    [ITEM_ID.ID_12]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_410]: {
      titleMaxSize: 12
    }
  },
  [BASE_ID.ID_45]: {
    watermark: {
      base_id: '45',
      groupId: '',
      id: '',
      items: [
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 13,
          style: 0,
          switchStatus: false,
          title: '防疫工作内容',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 14,
          style: 0,
          switchStatus: false,
          title: '单位名称',
          userCustom: false
        },
        {
          content: '日期+时刻',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 100,
          switchStatus: false,
          title: '时间',
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: false,
          title: '地点',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 15,
          style: 0,
          switchStatus: false,
          title: '操作员',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 12,
          style: 0,
          switchStatus: false,
          title: '备注',
          userCustom: false
        }
      ],
      name: '',
      update_time: '',
      version: '3'
    },
    allowCustomItem: false,
    optionItems: [1, 2],
    [ITEM_ID.ID_1]: {
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [100, 101, 102, 103, 104, 105, 106, 108]
    },
    [ITEM_ID.ID_2]: {
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_13]: {
      titleEditable: false,
      contentMaxSize: 260
    },
    [ITEM_ID.ID_14]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_15]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_12]: {
      titleEditable: false,
      contentMaxSize: 530
    }
  },
  [BASE_ID.ID_46]: {
    watermark: {
      base_id: '46',
      groupId: '',
      id: '',
      items: [
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 200,
          style: 0,
          switchStatus: false,
          title: '防盗图申明',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 11,
          style: 0,
          switchStatus: false,
          title: '宣传语',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 12,
          style: 0,
          switchStatus: false,
          title: '重点内容',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 13,
          style: 0,
          switchStatus: false,
          title: '业务简介',
          userCustom: false
        },
        {
          content: '日期+时刻',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 100,
          switchStatus: false,
          title: '时间',
          userCustom: false
        },
        {
          content: '天气+温度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 4,
          style: 200,
          switchStatus: false,
          title: '天气',
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: false,
          title: '地点',
          userCustom: false
        },
        {
          content: '高度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 5,
          style: 400,
          switchStatus: false,
          title: '海拔',
          userCustom: false
        },
        {
          content: '方向+角度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 6,
          style: 600,
          switchStatus: false,
          title: '方位角',
          userCustom: false
        },
        {
          content: '度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 3,
          style: 500,
          switchStatus: false,
          title: '经纬度',
          userCustom: false
        }
      ],
      logo: {
        alpha: '1.0',
        id: 120,
        scale: '0.23',
        switchStatus: false,
        url: ''
      },
      name: '',
      theme: {
        alpha: '1.0',
        color: '#ffef40',
        id: 110,
        switchStatus: true,
        textColor: '#ffffff'
      },
      update_time: '',
      version: '4'
    },
    allowCustomItem: false,
    optionItems: [1, 4, 2, 5, 6, 3],
    theme: {
      displayName: '主题颜色',
      editable: ['color', 'textColor']
    },
    logo: {
      displayName: '品牌图片',
      editable: ['scale', 'alpha']
    },
    [ITEM_ID.ID_1]: {
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [100, 101, 102, 103, 104, 105, 106, 108]
    },
    [ITEM_ID.ID_4]: {
      tooltip: TOOLTIPS.WEATHER,
      cardStyle: {
        width: '230px'
      },
      styles: WEATHER_STYLES,
      options: []
    },
    [ITEM_ID.ID_2]: {
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_5]: {
      tooltip: TOOLTIPS.ALTITUDE,
      cardStyle: {
        width: '230px'
      },
      styles: ALTITUDE_STYLES,
      options: [400]
    },
    [ITEM_ID.ID_6]: {
      tooltip: TOOLTIPS.AZIMUTH,
      cardStyle: {
        width: '230px'
      },
      styles: AZIMUTH_STYLES,
      options: [600]
    },
    [ITEM_ID.ID_3]: {
      tooltip: TOOLTIPS.GPS,
      cardStyle: {
        width: '230px'
      },
      styles: GPS_STYLES,
      options: [500, 501, 502]
    },
    [ITEM_ID.ID_200]: {
      titleEditable: false,
      contentMaxSize: 20
    },
    [ITEM_ID.ID_11]: {
      titleEditable: false,
      contentMaxSize: 260
    },
    [ITEM_ID.ID_12]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_13]: {
      titleEditable: 20,
      contentMaxSize: 530
    }
  },
  [BASE_ID.ID_35]: {
    watermark: {
      base_id: '35',
      groupId: '',
      id: '',
      items: [
        {
          content: '现场拍照',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 300,
          style: 0,
          switchStatus: false,
          title: '现场拍照水印',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: ['选项1', '选项2'],
            placeholder: ''
          },
          editType: 2,
          id: 30,
          style: 0,
          switchStatus: false,
          title: '手机号',
          userCustom: false
        },
        {
          content: '度（无单位）',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 3,
          style: 510,
          switchStatus: false,
          title: '经纬度',
          userCustom: false
        },
        {
          content: '城市+地点',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: false,
          title: '地址',
          userCustom: false
        },
        {
          content: '日期+时刻',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 107,
          switchStatus: false,
          title: '时间',
          userCustom: false
        },
        {
          content: '高度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 5,
          style: 400,
          switchStatus: false,
          title: '海拔',
          userCustom: false
        },
        {
          content: '天气+温度',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 4,
          style: 200,
          switchStatus: false,
          title: '天气',
          userCustom: false
        },
        {
          content: '手机串码（仅安卓设备）',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 500,
          style: 5000,
          switchStatus: false,
          title: 'IMEI',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: ['选项1', '选项2'],
            placeholder: ''
          },
          editType: 2,
          id: 12,
          style: 0,
          switchStatus: false,
          title: '备注',
          userCustom: false
        }
      ],
      name: '',
      theme: {
        id: 110,
        switchStatus: true,
        textColor: '#ffffff'
      },
      update_time: '',
      version: '2'
    },
    allowCustomItem: false,
    optionItems: [1, 2, 3, 4, 5, 300, 500],
    theme: {
      displayName: '字体颜色',
      editable: ['textColor']
    },
    [ITEM_ID.ID_1]: {
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [107]
    },
    [ITEM_ID.ID_4]: {
      tooltip: TOOLTIPS.WEATHER,
      cardStyle: {
        width: '230px'
      },
      styles: WEATHER_STYLES,
      options: []
    },
    [ITEM_ID.ID_2]: {
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_5]: {
      tooltip: TOOLTIPS.ALTITUDE,
      cardStyle: {
        width: '230px'
      },
      styles: ALTITUDE_STYLES,
      options: [400]
    },
    [ITEM_ID.ID_6]: {
      tooltip: TOOLTIPS.AZIMUTH,
      cardStyle: {
        width: '230px'
      },
      styles: AZIMUTH_STYLES,
      options: [600]
    },
    [ITEM_ID.ID_3]: {
      tooltip: TOOLTIPS.GPS,
      cardStyle: {
        width: '230px'
      },
      styles: GPS_STYLES,
      options: [510]
    },
    [ITEM_ID.ID_300]: {
      tooltip: TOOLTIPS.ID_300,
      styles: ID_300_STYLES,
      options: []
    },
    [ITEM_ID.ID_500]: {
      tooltip: TOOLTIPS.IMEI,
      styles: IMEI_STYLES,
      options: []
    },
    [ITEM_ID.ID_30]: {
      titleEditable: false
    },
    [ITEM_ID.ID_12]: {
      titleEditable: false,
      contentMaxSize: 530
    }
  },
  [BASE_ID.ID_50]: {
    watermark: {
      base_id: '50',
      groupId: '',
      id: '',
      items: [
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 13,
          style: 0,
          switchStatus: false,
          title: '主题',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 14,
          style: 0,
          switchStatus: false,
          title: '单位名称',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 15,
          style: 0,
          switchStatus: false,
          title: '民情书记',
          userCustom: false
        },
        {
          content: '',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 2,
          id: 16,
          style: 0,
          switchStatus: false,
          title: '受访对象',
          userCustom: false
        },
        {
          content: '2020.10.22  14:41',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 0,
          id: 1,
          style: 100,
          switchStatus: false,
          title: '时间',
          userCustom: false
        },
        {
          content: '北京市·颐泉汇',
          contentEdit: {
            editType: 0,
            itemsList: [],
            placeholder: ''
          },
          editType: 4,
          id: 2,
          style: 300,
          switchStatus: false,
          title: '地点',
          userCustom: false
        }
      ],
      name: '',
      update_time: '',
      version: '2'
    },
    allowCustomItem: true,
    customItem: {
      titleMaxSize: 20,
      contentMaxSize: 530
    },
    optionItems: [1, 2],
    [ITEM_ID.ID_1]: {
      tooltip: TOOLTIPS.DATE_TIME,
      styles: DATE_TIME_STYLES,
      options: [100, 101, 102, 103, 104, 105, 106, 108]
    },
    [ITEM_ID.ID_2]: {
      tooltip: TOOLTIPS.ADDRESS,
      cardStyle: {
        width: '240px'
      },
      styles: ADDRESS_STYLES,
      options: []
    },
    [ITEM_ID.ID_13]: {
      titleEditable: false,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_14]: {
      titleEditable: false,
      contentMaxSize: 260
    },
    [ITEM_ID.ID_15]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    },
    [ITEM_ID.ID_16]: {
      titleMaxSize: 12,
      contentMaxSize: 530
    }
  }
}

//生成自定义条目
export const generateCustomItem = () => {
  return {
    id: dayjs().unix(),
    switchStatus: true,
    title: '自定义项',
    content: '',
    editType: 2,
    style: 0,
    userCustom: true,
    contentEdit: {
      editType: 0,
      placeholder: '',
      itemsList: []
    }
  }
}

export const calculateScale = (sliderValue: number, base_id: string) => {
  if (base_id === BASE_ID.ID_20) {
    //font 0.46 - 1.6
    //size 0.7 - 1.5
    const config = WATERMARK_CONFIG[BASE_ID.ID_20]
    const theme = config?.theme
    if (!theme || !('minFont' in theme)) {
      return { fontScale: 1.0, sizeScale: 1.0 }
    }
    const { minFont, maxFont, minSize, maxSize } = theme as {
      minFont: number
      maxFont: number
      minSize: number
      maxSize: number
    }

    let fontScale = 1.0,
      sizeScale = 1.0
    if (sliderValue === 0) {
      fontScale = minFont
      sizeScale = minSize
    } else if (sliderValue > 0 && sliderValue < 1.0) {
      fontScale = minFont + (1.0 - minFont) * sliderValue
      sizeScale = minSize + (1.0 - minSize) * sliderValue
    } else if (sliderValue === 1.0) {
      fontScale = 1.0
      sizeScale = 1.0
    } else if (sliderValue > 1.0 && sliderValue < 2.0) {
      fontScale = 1.0 + (maxFont - 1.0) * (sliderValue - 1.0)
      sizeScale = 1.0 + (maxSize - 1.0) * (sliderValue - 1.0)
    } else if (sliderValue === 2.0) {
      fontScale = maxFont
      sizeScale = maxSize
    }
    return { fontScale, sizeScale }
  }
  if (base_id === BASE_ID.ID_10) {
    //font 0.4 - 1.4
    //size 0.6 - 1.2
    const config = WATERMARK_CONFIG[BASE_ID.ID_10]
    const theme = config?.theme
    if (!theme || !('minFont' in theme)) {
      return { fontScale: 1.0, sizeScale: 1.0 }
    }
    const { minFont, maxFont, minSize, maxSize } = theme as {
      minFont: number
      maxFont: number
      minSize: number
      maxSize: number
    }
    let fontScale = 1.0,
      sizeScale = 1.0
    if (sliderValue === 0) {
      fontScale = minFont
      sizeScale = minSize
    } else if (sliderValue > 0 && sliderValue < 1.0) {
      fontScale = minFont + (1.0 - minFont) * sliderValue
      sizeScale = minSize + (1.0 - minSize) * sliderValue
    } else if (sliderValue === 1.0) {
      fontScale = 1.0
      sizeScale = 1.0
    } else if (sliderValue > 1.0 && sliderValue < 2.0) {
      fontScale = 1.0 + (maxFont - 1.0) * (sliderValue - 1.0)
      sizeScale = 1.0 + (maxSize - 1.0) * (sliderValue - 1.0)
    } else if (sliderValue === 2.0) {
      fontScale = maxFont
      sizeScale = maxSize
    }
    return { fontScale, sizeScale }
  }
  return { fontScale: 1.0, sizeScale: 1.0 }
}

export const calculateSlider = (sizeScale, base_id) => {
  if (base_id === BASE_ID.ID_20) {
    // 0.7 -- 1  y1 = 0.8x + 0.7
    // 1 -- 1.5  y2 = 0.4x + 0.8
    let sliderValue = 1
    if (sizeScale > 1) {
      sliderValue = sizeScale - 0.5
    } else {
      sliderValue = (sizeScale - 0.7) / 0.6
    }
    return sliderValue * 2
  }
  if (base_id === BASE_ID.ID_10) {
    // 0.6 -- 1  y1 = 0.8x + 0.6
    // 1 -- 1.2  y2 = 0.4x + 0.8
    let sliderValue = 1
    if (sizeScale > 1) {
      sliderValue = (sizeScale - 0.8) / 0.4
    } else {
      sliderValue = (sizeScale - 0.6) / 0.8
    }
    return sliderValue * 2
  }
}

export const WM_STORAGE_KEYS = {
  WM: 'wmDrafts',
  WM_GROUPS: 'wmDraftGroups'
}
